import { useQuery } from '@tanstack/react-query';
import { get } from 'util/Api';
import API from 'constants/api';

interface Profile {
  ownerID?: string | number;
  logisticOperatorID?: number;
}

async function fetchZones(profile: Profile): Promise<unknown[]> {
  const response = await get(
    API.zones.getAllByLogisticOperator(profile.logisticOperatorID),
    { headers: { TENANT_KEY: profile.ownerID } },
  );
  return response.data ?? [];
}

export function useZonesQuery(profile: Profile | null | undefined) {
  return useQuery<unknown[]>({
    queryKey: ['zones', profile?.logisticOperatorID],
    queryFn: () => fetchZones(profile!),
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    enabled: !!profile?.logisticOperatorID,
  });
}
